/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Facts_LicenseInputs */

const en_vc_facts_license = /** @type {(inputs: Vc_Facts_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`License`)
};

const zh_vc_facts_license = /** @type {(inputs: Vc_Facts_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开源协议`)
};

/**
* | output |
* | --- |
* | "License" |
*
* @param {Vc_Facts_LicenseInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_facts_license = /** @type {((inputs?: Vc_Facts_LicenseInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Facts_LicenseInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_facts_license(inputs)
	return zh_vc_facts_license(inputs)
});
export { vc_facts_license as "vc.facts.license" }